import { Component, OnInit, Input } from '@angular/core';
import {Router} from '@angular/router';
import { MessageclientService} from '../../../service/messageclient.service';
import { CommonService} from '../../../service/common.service';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {
  @Input() Head:any;
  constructor(
    private router:Router,
    private msg:MessageclientService,
    private com:CommonService
  ) { }

  @Input() type:any;
  ngOnInit() {
  }
  eventClick(url:any){
    if(url){
      this.com.setHistoryUrl();
      this.com.Go(url+"/"+this.com.getNowDatetime);
    }else{
      this.msg.Loading("地址配置有误,请联系管理员");
    }
  }

}
